var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-handle",class:{
      'disabled': _vm.disabled,
      'horizontal': _vm.direction === 'horizontal',
      'vertical': _vm.direction === 'vertical'
    },on:{"mousedown":_vm.handleMouseDown,"click":_vm.onClickDragHandle}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03d91b2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/external/VueDragZone/handle.vue
// module id = null
// module chunks = 